@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.sidebar {
  background-color: map.get(core.$colors, accent);
  box-sizing: border-box;
  position: relative;
  transition: all 0.2s ease-out 0s;
  width: 220px;

  &Collapsed {
    width: 64px;
  }

  &Logo {
    background-repeat: no-repeat;
    display: inline-block;
    height: 40px;
    margin-bottom: 50px;
    transition: all 0.2s ease-out 0s;
    width: 130px;

    &Small {
      height: 26px;
      margin-left: 10px;
      width: 28px;
    }
  }

  &Container {
    display: flex;
    justify-content: space-between;
    margin: 26px 16px 20px;
    position: relative;
  }

  &Arrow {
    transition: all 0.2s ease-out 0s;
    cursor: pointer;

    &Inline {
      position: absolute;
      right: -2px;
      top: 4px;
    }

    &Collapsed {
      margin-left: 12px;
      position: absolute;
      top: 48px;
      transform: rotate(180deg);
    }

    &Icon {
      color: map.get(core.$colors, simpleWhite);
      height: 16px;
      width: 16px;
    }
  }

  &Column {
    margin: 26px 8px 20px;
    position: relative;
    display: flex;
  }
}
